module.exports = __webpack_public_path__ + "img/DOMAINBOOST.9b83ccbd.png";